//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes material
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
//Estilos
import ResultadoStyle from '../../styles/ResultadoStyle';

/**
 * Formata um número, validando se é um valor válido
 * @param {Number} valor Valor a ser formatado
 * @returns {String} Retorna o valor formatado como esperado
 */
function formatarNumero(valor) {
    if (valor === null || isNaN(valor))
        return '';
    else 
        return valor.toString();
}

/**
 * Renderiza as respostas do tipo inteiro
 * @param {Object} props
 * @param {Array<AvaliacaoResposta>} props.respostas Dados das respostas a serem exibidas
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoQuestaoInteiro({ respostas, classes }) {
    if (respostas.length === 0) return 'Nenhuma resposta encontrada';

    return (
        <TableRow>
            {
                respostas.map(resposta => (
                    <TableCell key={resposta.id}><Typography className={classes.texto} >{formatarNumero(resposta.resposta)}</Typography></TableCell>
                ))
            }
        </TableRow>
    );
}

ResultadoQuestaoInteiro.propTypes = {
    /** Dados das respostas a serem exibidas */
    respostas: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoResposta)).isRequired,
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoQuestaoInteiro);